import React from 'react';
import cls from "./atoms.module.scss"
import {TranslationsType} from "../types/homePageTypes";

interface ICustomTextAreaProps {
    className?: string | any,
    id?: string,
    type?: string,
    inpValue?: string,
    label: string,
    value: string,
    handleChange?: (event: { target: { value: string, name?: string } }) => void,
    withStar?: boolean,
    name?: string,
    required?: boolean
    custom?: boolean
}

export const CustomTextArea = ({
                                   inpValue,
                                   label,
                                   value,
                                   className,
                                   handleChange,
                                   withStar = false,
                                   custom = false,
                                   required,
                                   ...props
                               }: ICustomTextAreaProps) => {

    const LabelName = custom ? <span>{value}</span> : value
    return (
        <div className={cls.custom_textArea_checkout}>
            <textarea
                className={cls.custom_textarea}
                id={props.name}
                placeholder=" "
                required={!!required}
                autoComplete="off"
                value={inpValue}
                onChange={handleChange}
                {...props}
            />
            <label
                className={cls.custom_input_label}
                htmlFor={props.name}
            >
                {LabelName}
                {
                    withStar &&
                    <span className={cls["red-fms"]}> *</span>
                }
            </label>
        </div>
    )
}